import React from 'react'

const Header = () => {
  return (
    <header>
      <div className="bg-yellow-50 py-1">
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Harum laborum qui eligendi modi ab doloribus moles
      </div>
      <nav className='pt-5'>
        <h1 className='text-center text-4xl mb-5'>Commalax</h1>
        <ul className='flex gap-10 justify-center mb-10 pb-3'>
          <li className='cursor-pointer'>All Products</li>
          <li className='cursor-pointer'>New Arrival</li>
          <li className='cursor-pointer'>Bestseller</li>
          <li className='cursor-pointer'>Skin Care</li>
          <li className='cursor-pointer'>Body Care</li>
          <li className='cursor-pointer'>Make Up</li>
        </ul>
      </nav>
    </header>
  )
}

export default Header
